var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadDrumpad = function SvgFadDrumpad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64.001C32 46.328 46.333 32 64.001 32H192c17.672 0 32 14.333 32 32.001V192c0 17.672-14.333 32-32.001 32H64c-17.672 0-32-14.333-32-32.001V64z",
    fillRule: "evenodd"
  })));
};
export { SvgFadDrumpad as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-drumpad.54bbe9e8.svg";